/** This file is auto generated by convertSvgToJsx.ts */

import above_the_line from './dnb/above_the_line'
import above_the_line_medium from './dnb/above_the_line_medium'
import accessibility from './dnb/accessibility'
import accessibility_medium from './dnb/accessibility_medium'
import account from './dnb/account'
import account_card from './dnb/account_card'
import account_card_medium from './dnb/account_card_medium'
import account_in from './dnb/account_in'
import account_in_medium from './dnb/account_in_medium'
import account_medium from './dnb/account_medium'
import account_out from './dnb/account_out'
import account_out_medium from './dnb/account_out_medium'
import account_percent from './dnb/account_percent'
import account_percent_medium from './dnb/account_percent_medium'
import accounting from './dnb/accounting'
import accounting_medium from './dnb/accounting_medium'
import add from './dnb/add'
import add_circled from './dnb/add_circled'
import add_circled_medium from './dnb/add_circled_medium'
import add_medium from './dnb/add_medium'
import ai from './dnb/ai'
import ai_medium from './dnb/ai_medium'
import aino from './dnb/aino'
import aino_medium from './dnb/aino_medium'
import ainvoice from './dnb/ainvoice'
import ainvoice_medium from './dnb/ainvoice_medium'
import ambulance from './dnb/ambulance'
import ambulance_medium from './dnb/ambulance_medium'
import animal_print from './dnb/animal_print'
import animal_print_medium from './dnb/animal_print_medium'
import apple_watch from './dnb/apple_watch'
import apple_watch_medium from './dnb/apple_watch_medium'
import arrow_down from './dnb/arrow_down'
import arrow_down_medium from './dnb/arrow_down_medium'
import arrow_left from './dnb/arrow_left'
import arrow_left_medium from './dnb/arrow_left_medium'
import arrow_right from './dnb/arrow_right'
import arrow_right_medium from './dnb/arrow_right_medium'
import arrow_up from './dnb/arrow_up'
import arrow_up_medium from './dnb/arrow_up_medium'
import attachment from './dnb/attachment'
import attachment_medium from './dnb/attachment_medium'
import baby from './dnb/baby'
import baby_medium from './dnb/baby_medium'
import bandage from './dnb/bandage'
import bandage_medium from './dnb/bandage_medium'
import bank from './dnb/bank'
import bank_medium from './dnb/bank_medium'
import bankid from './dnb/bankid'
import bankid_medium from './dnb/bankid_medium'
import bankid_mobile from './dnb/bankid_mobile'
import bankid_mobile_medium from './dnb/bankid_mobile_medium'
import bankid_qr from './dnb/bankid_qr'
import bankid_qr_medium from './dnb/bankid_qr_medium'
import bell from './dnb/bell'
import bell_medium from './dnb/bell_medium'
import bicycle from './dnb/bicycle'
import bicycle_medium from './dnb/bicycle_medium'
import boat from './dnb/boat'
import boat_medium from './dnb/boat_medium'
import bookmark from './dnb/bookmark'
import bookmark_medium from './dnb/bookmark_medium'
import bowling from './dnb/bowling'
import bowling_medium from './dnb/bowling_medium'
import brickwall from './dnb/brickwall'
import brickwall_medium from './dnb/brickwall_medium'
import broken_chain from './dnb/broken_chain'
import broken_chain_medium from './dnb/broken_chain_medium'
import browser from './dnb/browser'
import browser_medium from './dnb/browser_medium'
import brush from './dnb/brush'
import brush_medium from './dnb/brush_medium'
import bsu from './dnb/bsu'
import bsu_medium from './dnb/bsu_medium'
import bubble from './dnb/bubble'
import bubble_medium from './dnb/bubble_medium'
import building_construction from './dnb/building_construction'
import building_construction_medium from './dnb/building_construction_medium'
import building_shopping from './dnb/building_shopping'
import building_shopping_medium from './dnb/building_shopping_medium'
import bus from './dnb/bus'
import bus_medium from './dnb/bus_medium'
import calculator from './dnb/calculator'
import calculator_medium from './dnb/calculator_medium'
import calendar from './dnb/calendar'
import calendar_add from './dnb/calendar_add'
import calendar_add_medium from './dnb/calendar_add_medium'
import calendar_cancel from './dnb/calendar_cancel'
import calendar_cancel_medium from './dnb/calendar_cancel_medium'
import calendar_medium from './dnb/calendar_medium'
import camera from './dnb/camera'
import camera_medium from './dnb/camera_medium'
import camper_trailer from './dnb/camper_trailer'
import camper_trailer_medium from './dnb/camper_trailer_medium'
import candle_stick from './dnb/candle_stick'
import candle_stick_medium from './dnb/candle_stick_medium'
import car_1 from './dnb/car_1'
import car_1_medium from './dnb/car_1_medium'
import car_2 from './dnb/car_2'
import car_2_medium from './dnb/car_2_medium'
import caravan from './dnb/caravan'
import caravan_medium from './dnb/caravan_medium'
import card from './dnb/card'
import card_in from './dnb/card_in'
import card_in_medium from './dnb/card_in_medium'
import card_medium from './dnb/card_medium'
import card_out from './dnb/card_out'
import card_out_medium from './dnb/card_out_medium'
import card_with_padlock from './dnb/card_with_padlock'
import card_with_padlock_medium from './dnb/card_with_padlock_medium'
import cat from './dnb/cat'
import cat_medium from './dnb/cat_medium'
import chain from './dnb/chain'
import chain_medium from './dnb/chain_medium'
import charger from './dnb/charger'
import charger_medium from './dnb/charger_medium'
import chat from './dnb/chat'
import chat_medium from './dnb/chat_medium'
import chatbot from './dnb/chatbot'
import chatbot_medium from './dnb/chatbot_medium'
import check from './dnb/check'
import check_medium from './dnb/check_medium'
import chevron_down from './dnb/chevron_down'
import chevron_down_medium from './dnb/chevron_down_medium'
import chevron_left from './dnb/chevron_left'
import chevron_left_medium from './dnb/chevron_left_medium'
import chevron_right from './dnb/chevron_right'
import chevron_right_medium from './dnb/chevron_right_medium'
import chevron_up from './dnb/chevron_up'
import chevron_up_medium from './dnb/chevron_up_medium'
import chip from './dnb/chip'
import chip_medium from './dnb/chip_medium'
import clearing_house from './dnb/clearing_house'
import clearing_house_medium from './dnb/clearing_house_medium'
import clock from './dnb/clock'
import clock_medium from './dnb/clock_medium'
import close from './dnb/close'
import close_medium from './dnb/close_medium'
import cloud from './dnb/cloud'
import cloud_download from './dnb/cloud_download'
import cloud_download_medium from './dnb/cloud_download_medium'
import cloud_medium from './dnb/cloud_medium'
import cloud_rain from './dnb/cloud_rain'
import cloud_rain_medium from './dnb/cloud_rain_medium'
import cloud_sync from './dnb/cloud_sync'
import cloud_sync_medium from './dnb/cloud_sync_medium'
import cloud_transfer from './dnb/cloud_transfer'
import cloud_transfer_medium from './dnb/cloud_transfer_medium'
import cloud_upload from './dnb/cloud_upload'
import cloud_upload_medium from './dnb/cloud_upload_medium'
import cog from './dnb/cog'
import cog_medium from './dnb/cog_medium'
import coins_1 from './dnb/coins_1'
import coins_1_medium from './dnb/coins_1_medium'
import coins_2 from './dnb/coins_2'
import coins_2_medium from './dnb/coins_2_medium'
import coins_3 from './dnb/coins_3'
import coins_3_medium from './dnb/coins_3_medium'
import compose from './dnb/compose'
import compose_medium from './dnb/compose_medium'
import confetti from './dnb/confetti'
import confetti_medium from './dnb/confetti_medium'
import contacts from './dnb/contacts'
import contacts_medium from './dnb/contacts_medium'
import cookie from './dnb/cookie'
import cookie_medium from './dnb/cookie_medium'
import copy from './dnb/copy'
import copy_medium from './dnb/copy_medium'
import credit_note from './dnb/credit_note'
import credit_note_medium from './dnb/credit_note_medium'
import currency from './dnb/currency'
import currency_medium from './dnb/currency_medium'
import customer_service from './dnb/customer_service'
import customer_service_medium from './dnb/customer_service_medium'
import deleted_invoice from './dnb/deleted_invoice'
import deleted_invoice_medium from './dnb/deleted_invoice_medium'
import diamond from './dnb/diamond'
import diamond_medium from './dnb/diamond_medium'
import digipass from './dnb/digipass'
import digipass_corporate from './dnb/digipass_corporate'
import digipass_corporate_medium from './dnb/digipass_corporate_medium'
import digipass_medium from './dnb/digipass_medium'
import digipass_private from './dnb/digipass_private'
import digipass_private_medium from './dnb/digipass_private_medium'
import digipost from './dnb/digipost'
import digipost_medium from './dnb/digipost_medium'
import digital_advise from './dnb/digital_advise'
import digital_advise_medium from './dnb/digital_advise_medium'
import digitpass_private_corporate from './dnb/digitpass_private_corporate'
import digitpass_private_corporate_medium from './dnb/digitpass_private_corporate_medium'
import dismiss_keyboard from './dnb/dismiss_keyboard'
import dismiss_keyboard_medium from './dnb/dismiss_keyboard_medium'
import dog from './dnb/dog'
import dog_medium from './dnb/dog_medium'
import download from './dnb/download'
import download_medium from './dnb/download_medium'
import e_scooter from './dnb/e_scooter'
import e_scooter_medium from './dnb/e_scooter_medium'
import edit from './dnb/edit'
import edit_medium from './dnb/edit_medium'
import einvoice from './dnb/einvoice'
import einvoice_medium from './dnb/einvoice_medium'
import email from './dnb/email'
import email_medium from './dnb/email_medium'
import envelope_open from './dnb/envelope_open'
import envelope_open_medium from './dnb/envelope_open_medium'
import equities_and_mutual_funds from './dnb/equities_and_mutual_funds'
import equities_and_mutual_funds_medium from './dnb/equities_and_mutual_funds_medium'
import exclamation from './dnb/exclamation'
import exclamation_circled from './dnb/exclamation_circled'
import exclamation_circled_medium from './dnb/exclamation_circled_medium'
import exclamation_medium from './dnb/exclamation_medium'
import exclamation_triangle from './dnb/exclamation_triangle'
import exclamation_triangle_medium from './dnb/exclamation_triangle_medium'
import facebook from './dnb/facebook'
import facebook_medium from './dnb/facebook_medium'
import factory from './dnb/factory'
import factory_medium from './dnb/factory_medium'
import file from './dnb/file'
import file_add from './dnb/file_add'
import file_add_medium from './dnb/file_add_medium'
import file_contract from './dnb/file_contract'
import file_contract_medium from './dnb/file_contract_medium'
import file_csv from './dnb/file_csv'
import file_csv_medium from './dnb/file_csv_medium'
import file_jpg from './dnb/file_jpg'
import file_jpg_medium from './dnb/file_jpg_medium'
import file_loupe from './dnb/file_loupe'
import file_loupe_medium from './dnb/file_loupe_medium'
import file_medium from './dnb/file_medium'
import file_pdf from './dnb/file_pdf'
import file_pdf_medium from './dnb/file_pdf_medium'
import file_png from './dnb/file_png'
import file_png_medium from './dnb/file_png_medium'
import file_ppt from './dnb/file_ppt'
import file_ppt_medium from './dnb/file_ppt_medium'
import file_rejected from './dnb/file_rejected'
import file_rejected_medium from './dnb/file_rejected_medium'
import file_signing from './dnb/file_signing'
import file_signing_medium from './dnb/file_signing_medium'
import file_txt from './dnb/file_txt'
import file_txt_medium from './dnb/file_txt_medium'
import file_warning from './dnb/file_warning'
import file_warning_medium from './dnb/file_warning_medium'
import file_word from './dnb/file_word'
import file_word_medium from './dnb/file_word_medium'
import file_xls from './dnb/file_xls'
import file_xls_medium from './dnb/file_xls_medium'
import file_xml from './dnb/file_xml'
import file_xml_medium from './dnb/file_xml_medium'
import file_zip from './dnb/file_zip'
import file_zip_medium from './dnb/file_zip_medium'
import filter from './dnb/filter'
import filter_medium from './dnb/filter_medium'
import first_aid from './dnb/first_aid'
import first_aid_medium from './dnb/first_aid_medium'
import fish from './dnb/fish'
import fish_medium from './dnb/fish_medium'
import flying_money from './dnb/flying_money'
import flying_money_medium from './dnb/flying_money_medium'
import folder from './dnb/folder'
import folder_medium from './dnb/folder_medium'
import football from './dnb/football'
import football_medium from './dnb/football_medium'
import fortune_ball from './dnb/fortune_ball'
import fortune_ball_medium from './dnb/fortune_ball_medium'
import fridge from './dnb/fridge'
import fridge_medium from './dnb/fridge_medium'
import fullscreen from './dnb/fullscreen'
import fullscreen_medium from './dnb/fullscreen_medium'
import funds from './dnb/funds'
import funds_in from './dnb/funds_in'
import funds_in_medium from './dnb/funds_in_medium'
import funds_medium from './dnb/funds_medium'
import funds_out from './dnb/funds_out'
import funds_out_medium from './dnb/funds_out_medium'
import globe from './dnb/globe'
import globe_medium from './dnb/globe_medium'
import goal from './dnb/goal'
import goal_medium from './dnb/goal_medium'
import grabber from './dnb/grabber'
import grabber_medium from './dnb/grabber_medium'
import graph_decrease from './dnb/graph_decrease'
import graph_decrease_medium from './dnb/graph_decrease_medium'
import graph_increase from './dnb/graph_increase'
import graph_increase_medium from './dnb/graph_increase_medium'
import hamburger from './dnb/hamburger'
import hamburger_medium from './dnb/hamburger_medium'
import hand_money from './dnb/hand_money'
import hand_money_medium from './dnb/hand_money_medium'
import handshake from './dnb/handshake'
import handshake_medium from './dnb/handshake_medium'
import hanger from './dnb/hanger'
import hanger_medium from './dnb/hanger_medium'
import heart from './dnb/heart'
import heart_medium from './dnb/heart_medium'
import heart_rate from './dnb/heart_rate'
import heart_rate_medium from './dnb/heart_rate_medium'
import heavy_equipment from './dnb/heavy_equipment'
import heavy_equipment_medium from './dnb/heavy_equipment_medium'
import hide from './dnb/hide'
import hide_medium from './dnb/hide_medium'
import hierarchy from './dnb/hierarchy'
import hierarchy_medium from './dnb/hierarchy_medium'
import history from './dnb/history'
import history_medium from './dnb/history_medium'
import holiday_home from './dnb/holiday_home'
import holiday_home_medium from './dnb/holiday_home_medium'
import home from './dnb/home'
import home_medium from './dnb/home_medium'
import horse from './dnb/horse'
import horse_medium from './dnb/horse_medium'
import hourglass from './dnb/hourglass'
import hourglass_medium from './dnb/hourglass_medium'
import house_1 from './dnb/house_1'
import house_1_medium from './dnb/house_1_medium'
import house_2 from './dnb/house_2'
import house_2_medium from './dnb/house_2_medium'
import house_value from './dnb/house_value'
import house_value_medium from './dnb/house_value_medium'
import id_card from './dnb/id_card'
import id_card_medium from './dnb/id_card_medium'
import information from './dnb/information'
import information_bubble from './dnb/information_bubble'
import information_bubble_medium from './dnb/information_bubble_medium'
import information_circled from './dnb/information_circled'
import information_circled_medium from './dnb/information_circled_medium'
import information_medium from './dnb/information_medium'
import instagram from './dnb/instagram'
import instagram_medium from './dnb/instagram_medium'
import insurance from './dnb/insurance'
import insurance_medium from './dnb/insurance_medium'
import investment_account from './dnb/investment_account'
import investment_account_medium from './dnb/investment_account_medium'
import investor from './dnb/investor'
import investor_medium from './dnb/investor_medium'
import keyfigures from './dnb/keyfigures'
import keyfigures_medium from './dnb/keyfigures_medium'
import kid_number from './dnb/kid_number'
import kid_number_medium from './dnb/kid_number_medium'
import language from './dnb/language'
import language_medium from './dnb/language_medium'
import laptop from './dnb/laptop'
import laptop_medium from './dnb/laptop_medium'
import launch from './dnb/launch'
import launch_medium from './dnb/launch_medium'
import layout_card from './dnb/layout_card'
import layout_card_medium from './dnb/layout_card_medium'
import layout_grid from './dnb/layout_grid'
import layout_grid_medium from './dnb/layout_grid_medium'
import leaf from './dnb/leaf'
import leaf_medium from './dnb/leaf_medium'
import lightbulb from './dnb/lightbulb'
import lightbulb_medium from './dnb/lightbulb_medium'
import lightningstrike from './dnb/lightningstrike'
import lightningstrike_medium from './dnb/lightningstrike_medium'
import linkedin from './dnb/linkedin'
import linkedin_medium from './dnb/linkedin_medium'
import list from './dnb/list'
import list_medium from './dnb/list_medium'
import loan from './dnb/loan'
import loan_in from './dnb/loan_in'
import loan_in_medium from './dnb/loan_in_medium'
import loan_medium from './dnb/loan_medium'
import loan_out from './dnb/loan_out'
import loan_out_medium from './dnb/loan_out_medium'
import location from './dnb/location'
import location_medium from './dnb/location_medium'
import log_in from './dnb/log_in'
import log_in_medium from './dnb/log_in_medium'
import log_out from './dnb/log_out'
import log_out_medium from './dnb/log_out_medium'
import loupe from './dnb/loupe'
import loupe_medium from './dnb/loupe_medium'
import mastercard from './dnb/mastercard'
import mastercard_card from './dnb/mastercard_card'
import mastercard_card_medium from './dnb/mastercard_card_medium'
import mastercard_medium from './dnb/mastercard_medium'
import megaphone from './dnb/megaphone'
import megaphone_medium from './dnb/megaphone_medium'
import microphone from './dnb/microphone'
import microphone_medium from './dnb/microphone_medium'
import minimize from './dnb/minimize'
import minimize_medium from './dnb/minimize_medium'
import mobile from './dnb/mobile'
import mobile_medium from './dnb/mobile_medium'
import mobilephone from './dnb/mobilephone'
import mobilephone_medium from './dnb/mobilephone_medium'
import money_left from './dnb/money_left'
import money_left_medium from './dnb/money_left_medium'
import moneybag_in_hand from './dnb/moneybag_in_hand'
import moneybag_in_hand_medium from './dnb/moneybag_in_hand_medium'
import moon from './dnb/moon'
import moon_medium from './dnb/moon_medium'
import more from './dnb/more'
import more_medium from './dnb/more_medium'
import more_vertical from './dnb/more_vertical'
import more_vertical_medium from './dnb/more_vertical_medium'
import motorcycle from './dnb/motorcycle'
import motorcycle_medium from './dnb/motorcycle_medium'
import move from './dnb/move'
import move_medium from './dnb/move_medium'
import news from './dnb/news'
import news_medium from './dnb/news_medium'
import newspaper from './dnb/newspaper'
import newspaper_medium from './dnb/newspaper_medium'
import office_buildings from './dnb/office_buildings'
import office_buildings_medium from './dnb/office_buildings_medium'
import oil from './dnb/oil'
import oil_medium from './dnb/oil_medium'
import owl from './dnb/owl'
import owl_medium from './dnb/owl_medium'
import padlock from './dnb/padlock'
import padlock_medium from './dnb/padlock_medium'
import paperclip from './dnb/paperclip'
import paperclip_medium from './dnb/paperclip_medium'
import paragraph from './dnb/paragraph'
import paragraph_medium from './dnb/paragraph_medium'
import passkey from './dnb/passkey'
import passkey_medium from './dnb/passkey_medium'
import pause from './dnb/pause'
import pause_medium from './dnb/pause_medium'
import pay_from from './dnb/pay_from'
import pay_from_medium from './dnb/pay_from_medium'
import pension from './dnb/pension'
import pension_medium from './dnb/pension_medium'
import people_1 from './dnb/people_1'
import people_1_medium from './dnb/people_1_medium'
import people_2 from './dnb/people_2'
import people_2_medium from './dnb/people_2_medium'
import person from './dnb/person'
import person_medium from './dnb/person_medium'
import person_shield from './dnb/person_shield'
import person_shield_medium from './dnb/person_shield_medium'
import phone from './dnb/phone'
import phone_medium from './dnb/phone_medium'
import photo from './dnb/photo'
import photo_medium from './dnb/photo_medium'
import pin from './dnb/pin'
import pin_code from './dnb/pin_code'
import pin_code_medium from './dnb/pin_code_medium'
import pin_medium from './dnb/pin_medium'
import plant from './dnb/plant'
import plant_medium from './dnb/plant_medium'
import play from './dnb/play'
import play_medium from './dnb/play_medium'
import plot from './dnb/plot'
import plot_medium from './dnb/plot_medium'
import podcast from './dnb/podcast'
import podcast_medium from './dnb/podcast_medium'
import portfolio_analytics from './dnb/portfolio_analytics'
import portfolio_analytics_medium from './dnb/portfolio_analytics_medium'
import printer from './dnb/printer'
import printer_medium from './dnb/printer_medium'
import profile from './dnb/profile'
import profile_medium from './dnb/profile_medium'
import progress from './dnb/progress'
import progress_medium from './dnb/progress_medium'
import question from './dnb/question'
import question_circled from './dnb/question_circled'
import question_circled_medium from './dnb/question_circled_medium'
import question_medium from './dnb/question_medium'
import recurring from './dnb/recurring'
import recurring_medium from './dnb/recurring_medium'
import redo from './dnb/redo'
import redo_medium from './dnb/redo_medium'
import ref_number from './dnb/ref_number'
import ref_number_medium from './dnb/ref_number_medium'
import refresh from './dnb/refresh'
import refresh_medium from './dnb/refresh_medium'
import reply from './dnb/reply'
import reply_medium from './dnb/reply_medium'
import reset from './dnb/reset'
import reset_medium from './dnb/reset_medium'
import restaurant from './dnb/restaurant'
import restaurant_medium from './dnb/restaurant_medium'
import return_1 from './dnb/return_1'
import return_1_medium from './dnb/return_1_medium'
import save from './dnb/save'
import save_medium from './dnb/save_medium'
import savings_account from './dnb/savings_account'
import savings_account_in from './dnb/savings_account_in'
import savings_account_in_medium from './dnb/savings_account_in_medium'
import savings_account_medium from './dnb/savings_account_medium'
import savings_account_out from './dnb/savings_account_out'
import savings_account_out_medium from './dnb/savings_account_out_medium'
import scan from './dnb/scan'
import scan_medium from './dnb/scan_medium'
import scissors from './dnb/scissors'
import scissors_medium from './dnb/scissors_medium'
import scooter from './dnb/scooter'
import scooter_medium from './dnb/scooter_medium'
import sea_transport from './dnb/sea_transport'
import sea_transport_medium from './dnb/sea_transport_medium'
import send from './dnb/send'
import send_medium from './dnb/send_medium'
import share_android from './dnb/share_android'
import share_android_medium from './dnb/share_android_medium'
import share_ios from './dnb/share_ios'
import share_ios_medium from './dnb/share_ios_medium'
import shield from './dnb/shield'
import shield_lock from './dnb/shield_lock'
import shield_lock_medium from './dnb/shield_lock_medium'
import shield_medium from './dnb/shield_medium'
import shopping_cart from './dnb/shopping_cart'
import shopping_cart_medium from './dnb/shopping_cart_medium'
import show_pin from './dnb/show_pin'
import show_pin_medium from './dnb/show_pin_medium'
import snowmobile from './dnb/snowmobile'
import snowmobile_medium from './dnb/snowmobile_medium'
import sort from './dnb/sort'
import sort_medium from './dnb/sort_medium'
import speedometer from './dnb/speedometer'
import speedometer_medium from './dnb/speedometer_medium'
import split from './dnb/split'
import split_medium from './dnb/split_medium'
import star from './dnb/star'
import star_medium from './dnb/star_medium'
import stocks from './dnb/stocks'
import stocks_medium from './dnb/stocks_medium'
import stop from './dnb/stop'
import stop_medium from './dnb/stop_medium'
import stop_square from './dnb/stop_square'
import stop_square_medium from './dnb/stop_square_medium'
import stopwatch from './dnb/stopwatch'
import stopwatch_medium from './dnb/stopwatch_medium'
import subtract from './dnb/subtract'
import subtract_circled from './dnb/subtract_circled'
import subtract_circled_medium from './dnb/subtract_circled_medium'
import subtract_medium from './dnb/subtract_medium'
import sun from './dnb/sun'
import sun_medium from './dnb/sun_medium'
import support from './dnb/support'
import support_medium from './dnb/support_medium'
import swap from './dnb/swap'
import swap_medium from './dnb/swap_medium'
import table from './dnb/table'
import table_medium from './dnb/table_medium'
import tag from './dnb/tag'
import tag_medium from './dnb/tag_medium'
import teenager from './dnb/teenager'
import teenager_medium from './dnb/teenager_medium'
import thumbs_down from './dnb/thumbs_down'
import thumbs_down_medium from './dnb/thumbs_down_medium'
import thumbs_up from './dnb/thumbs_up'
import thumbs_up_medium from './dnb/thumbs_up_medium'
import tractor from './dnb/tractor'
import tractor_medium from './dnb/tractor_medium'
import trailer from './dnb/trailer'
import trailer_medium from './dnb/trailer_medium'
import train from './dnb/train'
import train_medium from './dnb/train_medium'
import transfer from './dnb/transfer'
import transfer_medium from './dnb/transfer_medium'
import transfer_to from './dnb/transfer_to'
import transfer_to_medium from './dnb/transfer_to_medium'
import trash from './dnb/trash'
import trash_medium from './dnb/trash_medium'
import travel from './dnb/travel'
import travel_medium from './dnb/travel_medium'
import undo from './dnb/undo'
import undo_medium from './dnb/undo_medium'
import unlock from './dnb/unlock'
import unlock_medium from './dnb/unlock_medium'
import upload from './dnb/upload'
import upload_medium from './dnb/upload_medium'
import user_feedback from './dnb/user_feedback'
import user_feedback_medium from './dnb/user_feedback_medium'
import video from './dnb/video'
import video_medium from './dnb/video_medium'
import view from './dnb/view'
import view_medium from './dnb/view_medium'
import vintage_car from './dnb/vintage_car'
import vintage_car_medium from './dnb/vintage_car_medium'
import volume_off from './dnb/volume_off'
import volume_off_medium from './dnb/volume_off_medium'
import volume_on from './dnb/volume_on'
import volume_on_medium from './dnb/volume_on_medium'
import wallet from './dnb/wallet'
import wallet_medium from './dnb/wallet_medium'
import wearables from './dnb/wearables'
import wearables_medium from './dnb/wearables_medium'
import web from './dnb/web'
import web_medium from './dnb/web_medium'
import wheelchair from './dnb/wheelchair'
import wheelchair_medium from './dnb/wheelchair_medium'
import widget_android from './dnb/widget_android'
import widget_android_medium from './dnb/widget_android_medium'
import widget_ios from './dnb/widget_ios'
import widget_ios_medium from './dnb/widget_ios_medium'

export {
  above_the_line,
  above_the_line_medium,
  accessibility,
  accessibility_medium,
  account,
  account_card,
  account_card_medium,
  account_in,
  account_in_medium,
  account_medium,
  account_out,
  account_out_medium,
  account_percent,
  account_percent_medium,
  accounting,
  accounting_medium,
  add,
  add_circled,
  add_circled_medium,
  add_medium,
  ai,
  ai_medium,
  aino,
  aino_medium,
  ainvoice,
  ainvoice_medium,
  ambulance,
  ambulance_medium,
  animal_print,
  animal_print_medium,
  apple_watch,
  apple_watch_medium,
  arrow_down,
  arrow_down_medium,
  arrow_left,
  arrow_left_medium,
  arrow_right,
  arrow_right_medium,
  arrow_up,
  arrow_up_medium,
  attachment,
  attachment_medium,
  baby,
  baby_medium,
  bandage,
  bandage_medium,
  bank,
  bank_medium,
  bankid,
  bankid_medium,
  bankid_mobile,
  bankid_mobile_medium,
  bankid_qr,
  bankid_qr_medium,
  bell,
  bell_medium,
  bicycle,
  bicycle_medium,
  boat,
  boat_medium,
  bookmark,
  bookmark_medium,
  bowling,
  bowling_medium,
  brickwall,
  brickwall_medium,
  broken_chain,
  broken_chain_medium,
  browser,
  browser_medium,
  brush,
  brush_medium,
  bsu,
  bsu_medium,
  bubble,
  bubble_medium,
  building_construction,
  building_construction_medium,
  building_shopping,
  building_shopping_medium,
  bus,
  bus_medium,
  calculator,
  calculator_medium,
  calendar,
  calendar_add,
  calendar_add_medium,
  calendar_cancel,
  calendar_cancel_medium,
  calendar_medium,
  camera,
  camera_medium,
  camper_trailer,
  camper_trailer_medium,
  candle_stick,
  candle_stick_medium,
  car_1,
  car_1_medium,
  car_2,
  car_2_medium,
  caravan,
  caravan_medium,
  card,
  card_in,
  card_in_medium,
  card_medium,
  card_out,
  card_out_medium,
  card_with_padlock,
  card_with_padlock_medium,
  cat,
  cat_medium,
  chain,
  chain_medium,
  charger,
  charger_medium,
  chat,
  chat_medium,
  chatbot,
  chatbot_medium,
  check,
  check_medium,
  chevron_down,
  chevron_down_medium,
  chevron_left,
  chevron_left_medium,
  chevron_right,
  chevron_right_medium,
  chevron_up,
  chevron_up_medium,
  chip,
  chip_medium,
  clearing_house,
  clearing_house_medium,
  clock,
  clock_medium,
  close,
  close_medium,
  cloud,
  cloud_download,
  cloud_download_medium,
  cloud_medium,
  cloud_rain,
  cloud_rain_medium,
  cloud_sync,
  cloud_sync_medium,
  cloud_transfer,
  cloud_transfer_medium,
  cloud_upload,
  cloud_upload_medium,
  cog,
  cog_medium,
  coins_1,
  coins_1_medium,
  coins_2,
  coins_2_medium,
  coins_3,
  coins_3_medium,
  compose,
  compose_medium,
  confetti,
  confetti_medium,
  contacts,
  contacts_medium,
  cookie,
  cookie_medium,
  copy,
  copy_medium,
  credit_note,
  credit_note_medium,
  currency,
  currency_medium,
  customer_service,
  customer_service_medium,
  deleted_invoice,
  deleted_invoice_medium,
  diamond,
  diamond_medium,
  digipass,
  digipass_corporate,
  digipass_corporate_medium,
  digipass_medium,
  digipass_private,
  digipass_private_medium,
  digipost,
  digipost_medium,
  digital_advise,
  digital_advise_medium,
  digitpass_private_corporate,
  digitpass_private_corporate_medium,
  dismiss_keyboard,
  dismiss_keyboard_medium,
  dog,
  dog_medium,
  download,
  download_medium,
  e_scooter,
  e_scooter_medium,
  edit,
  edit_medium,
  einvoice,
  einvoice_medium,
  email,
  email_medium,
  envelope_open,
  envelope_open_medium,
  equities_and_mutual_funds,
  equities_and_mutual_funds_medium,
  exclamation,
  exclamation_circled,
  exclamation_circled_medium,
  exclamation_medium,
  exclamation_triangle,
  exclamation_triangle_medium,
  facebook,
  facebook_medium,
  factory,
  factory_medium,
  file,
  file_add,
  file_add_medium,
  file_contract,
  file_contract_medium,
  file_csv,
  file_csv_medium,
  file_jpg,
  file_jpg_medium,
  file_loupe,
  file_loupe_medium,
  file_medium,
  file_pdf,
  file_pdf_medium,
  file_png,
  file_png_medium,
  file_ppt,
  file_ppt_medium,
  file_rejected,
  file_rejected_medium,
  file_signing,
  file_signing_medium,
  file_txt,
  file_txt_medium,
  file_warning,
  file_warning_medium,
  file_word,
  file_word_medium,
  file_xls,
  file_xls_medium,
  file_xml,
  file_xml_medium,
  file_zip,
  file_zip_medium,
  filter,
  filter_medium,
  first_aid,
  first_aid_medium,
  fish,
  fish_medium,
  flying_money,
  flying_money_medium,
  folder,
  folder_medium,
  football,
  football_medium,
  fortune_ball,
  fortune_ball_medium,
  fridge,
  fridge_medium,
  fullscreen,
  fullscreen_medium,
  funds,
  funds_in,
  funds_in_medium,
  funds_medium,
  funds_out,
  funds_out_medium,
  globe,
  globe_medium,
  goal,
  goal_medium,
  grabber,
  grabber_medium,
  graph_decrease,
  graph_decrease_medium,
  graph_increase,
  graph_increase_medium,
  hamburger,
  hamburger_medium,
  hand_money,
  hand_money_medium,
  handshake,
  handshake_medium,
  hanger,
  hanger_medium,
  heart,
  heart_medium,
  heart_rate,
  heart_rate_medium,
  heavy_equipment,
  heavy_equipment_medium,
  hide,
  hide_medium,
  hierarchy,
  hierarchy_medium,
  history,
  history_medium,
  holiday_home,
  holiday_home_medium,
  home,
  home_medium,
  horse,
  horse_medium,
  hourglass,
  hourglass_medium,
  house_1,
  house_1_medium,
  house_2,
  house_2_medium,
  house_value,
  house_value_medium,
  id_card,
  id_card_medium,
  information,
  information_bubble,
  information_bubble_medium,
  information_circled,
  information_circled_medium,
  information_medium,
  instagram,
  instagram_medium,
  insurance,
  insurance_medium,
  investment_account,
  investment_account_medium,
  investor,
  investor_medium,
  keyfigures,
  keyfigures_medium,
  kid_number,
  kid_number_medium,
  language,
  language_medium,
  laptop,
  laptop_medium,
  launch,
  launch_medium,
  layout_card,
  layout_card_medium,
  layout_grid,
  layout_grid_medium,
  leaf,
  leaf_medium,
  lightbulb,
  lightbulb_medium,
  lightningstrike,
  lightningstrike_medium,
  linkedin,
  linkedin_medium,
  list,
  list_medium,
  loan,
  loan_in,
  loan_in_medium,
  loan_medium,
  loan_out,
  loan_out_medium,
  location,
  location_medium,
  log_in,
  log_in_medium,
  log_out,
  log_out_medium,
  loupe,
  loupe_medium,
  mastercard,
  mastercard_card,
  mastercard_card_medium,
  mastercard_medium,
  megaphone,
  megaphone_medium,
  microphone,
  microphone_medium,
  minimize,
  minimize_medium,
  mobile,
  mobile_medium,
  mobilephone,
  mobilephone_medium,
  money_left,
  money_left_medium,
  moneybag_in_hand,
  moneybag_in_hand_medium,
  moon,
  moon_medium,
  more,
  more_medium,
  more_vertical,
  more_vertical_medium,
  motorcycle,
  motorcycle_medium,
  move,
  move_medium,
  news,
  news_medium,
  newspaper,
  newspaper_medium,
  office_buildings,
  office_buildings_medium,
  oil,
  oil_medium,
  owl,
  owl_medium,
  padlock,
  padlock_medium,
  paperclip,
  paperclip_medium,
  paragraph,
  paragraph_medium,
  passkey,
  passkey_medium,
  pause,
  pause_medium,
  pay_from,
  pay_from_medium,
  pension,
  pension_medium,
  people_1,
  people_1_medium,
  people_2,
  people_2_medium,
  person,
  person_medium,
  person_shield,
  person_shield_medium,
  phone,
  phone_medium,
  photo,
  photo_medium,
  pin,
  pin_code,
  pin_code_medium,
  pin_medium,
  plant,
  plant_medium,
  play,
  play_medium,
  plot,
  plot_medium,
  podcast,
  podcast_medium,
  portfolio_analytics,
  portfolio_analytics_medium,
  printer,
  printer_medium,
  profile,
  profile_medium,
  progress,
  progress_medium,
  question,
  question_circled,
  question_circled_medium,
  question_medium,
  recurring,
  recurring_medium,
  redo,
  redo_medium,
  ref_number,
  ref_number_medium,
  refresh,
  refresh_medium,
  reply,
  reply_medium,
  reset,
  reset_medium,
  restaurant,
  restaurant_medium,
  return_1,
  return_1_medium,
  save,
  save_medium,
  savings_account,
  savings_account_in,
  savings_account_in_medium,
  savings_account_medium,
  savings_account_out,
  savings_account_out_medium,
  scan,
  scan_medium,
  scissors,
  scissors_medium,
  scooter,
  scooter_medium,
  sea_transport,
  sea_transport_medium,
  send,
  send_medium,
  share_android,
  share_android_medium,
  share_ios,
  share_ios_medium,
  shield,
  shield_lock,
  shield_lock_medium,
  shield_medium,
  shopping_cart,
  shopping_cart_medium,
  show_pin,
  show_pin_medium,
  snowmobile,
  snowmobile_medium,
  sort,
  sort_medium,
  speedometer,
  speedometer_medium,
  split,
  split_medium,
  star,
  star_medium,
  stocks,
  stocks_medium,
  stop,
  stop_medium,
  stop_square,
  stop_square_medium,
  stopwatch,
  stopwatch_medium,
  subtract,
  subtract_circled,
  subtract_circled_medium,
  subtract_medium,
  sun,
  sun_medium,
  support,
  support_medium,
  swap,
  swap_medium,
  table,
  table_medium,
  tag,
  tag_medium,
  teenager,
  teenager_medium,
  thumbs_down,
  thumbs_down_medium,
  thumbs_up,
  thumbs_up_medium,
  tractor,
  tractor_medium,
  trailer,
  trailer_medium,
  train,
  train_medium,
  transfer,
  transfer_medium,
  transfer_to,
  transfer_to_medium,
  trash,
  trash_medium,
  travel,
  travel_medium,
  undo,
  undo_medium,
  unlock,
  unlock_medium,
  upload,
  upload_medium,
  user_feedback,
  user_feedback_medium,
  video,
  video_medium,
  view,
  view_medium,
  vintage_car,
  vintage_car_medium,
  volume_off,
  volume_off_medium,
  volume_on,
  volume_on_medium,
  wallet,
  wallet_medium,
  wearables,
  wearables_medium,
  web,
  web_medium,
  wheelchair,
  wheelchair_medium,
  widget_android,
  widget_android_medium,
  widget_ios,
  widget_ios_medium,
}
